// extracted by mini-css-extract-plugin
export default {"customerRow":"hL02om0tJ29iiT4WqMQD","inventoryBox":"zDoO4rjeZC8Abaynpws5","inventoryRow":"Gjr31pdaWKv6N2QXUl7L"};